import { Box, Button, Stack, SxProps, Theme, Tooltip, Typography } from "@mui/material";
import { MouseEventHandler, ReactElement } from "react";

export interface IMessageActionButtonProps {
  buttonText: string;
  tooltipText: string;
  disableButton: boolean;
  disabledTooltipText: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  sendCount: number;
  isGroup: boolean;
  "data-test": string;
  sx?: SxProps<Theme>;
  ToggleNotificationAlerts?: ReactElement;
  showCount?: boolean;
}

export const MessageActionButton = ({
  buttonText,
  tooltipText,
  disableButton,
  disabledTooltipText,
  onClick,
  sendCount,
  isGroup,
  "data-test": dataTest,
  sx,
  ToggleNotificationAlerts,
  showCount = true,
}: IMessageActionButtonProps) => (
  <Box sx={{ ...sx }}>
    <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end">
      {showCount && (
        <Typography fontStyle="italic" fontWeight="normal" sx={{ marginRight: "10px" }}>
          Sending to <strong>{isGroup ? (sendCount === 0 ? "all" : sendCount) : sendCount}</strong> candidate
          {sendCount === 1 ? "" : "s"}
        </Typography>
      )}
      <Tooltip title={disableButton ? disabledTooltipText : tooltipText} arrow>
        <Box>
          <Button
            data-test={dataTest}
            variant="contained"
            color="primary"
            disabled={disableButton}
            onClick={disableButton ? undefined : onClick}
            sx={{ minHeight: "40px", margin: 0, px: 4 }}
          >
            {buttonText}
          </Button>
        </Box>
      </Tooltip>
      {ToggleNotificationAlerts}
    </Stack>
  </Box>
);
